import { BaseEntityClass } from "@shared/services/event_tracking/entities/base_entity_class";

interface ProductSortingEntityParams {
  value: string;
}
export class ProductSortingEntity extends BaseEntityClass {
  value: string;
  constructor(params: ProductSortingEntityParams) {
    super();
    this.type = "product-sorting";
    this.entity_version = 2;
    this.value = params.value;
  }
}
